import * as R from 'ramda'
import camelCase from 'camelcase'
import fastSafeStringify from 'fast-safe-stringify'

// stringify that can handle exotic objects e.g. with cyclical references
// useful for debugging and stringifying javascript errors etc.
export const stringify = (obj, replacer, space) => {
  try {
    return JSON.stringify(obj, replacer, space)
  } catch (e) {
    return fastSafeStringify(obj, replacer, space, { depthLimit: 4 })
  }
}

// convert python style snake_case to camelCase in json objects
export const camelConverter = obj =>
  R.cond([
    [R.is(Array), R.map(camelConverter)],
    [
      R.is(Object),
      R.pipe(
        R.toPairs,
        R.map(([key, val]) => [
          key.match(/_/) ? camelCase(key) : key,
          camelConverter(val),
        ]),
        R.fromPairs,
      ),
    ],
    [R.T, R.identity],
  ])(obj)
